const request = {
    invalid_input: "L'entrée est invalide. {{details}}",
    general: "Une erreur de requête s'est produite.",
    range_not_satisfiable: 'Plage non satisfaisable.',
};
export default Object.freeze(request);
